document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-alpha-menu-toggle]');
  const nav = document.querySelector('[data-alpha-nav]');
  const navClose = document.querySelector('[data-alpha-nav-close]');
  const navBackdrop = document.querySelector('[data-alpha-nav-backdrop]');

  function openNav() {
    nav?.classList.add('is-open');
    document.body.classList.add('alpha-nav-lock');
  }

  function closeNav() {
    nav?.classList.remove('is-open');
    document.body.classList.remove('alpha-nav-lock');
  }

  toggle?.addEventListener('click', () => {
    if (nav?.classList.contains('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });
  navClose?.addEventListener('click', closeNav);
  navBackdrop?.addEventListener('click', closeNav);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeNav();
  });

  document.querySelectorAll('.alpha-megamenu').forEach((menu) => {
    const links = menu.querySelectorAll('[data-mm-collection-link]');
    const panels = menu.querySelectorAll('[data-mm-panel]');
    links.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        const index = link.dataset.mmCollectionLink;
        links.forEach((l) => l.classList.toggle('is-active', l === link));
        panels.forEach((p) => p.classList.toggle('is-active', p.dataset.mmPanel === index));
      });
    });
  });

  document.querySelectorAll('[data-accessory-combo]').forEach((section) => {
    const moneyFormat = section.dataset.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    const basePrice = parseInt(section.dataset.basePrice || '0', 10);
    const totalEl = section.querySelector('[data-combo-total]');
    const addButton = section.querySelector('[data-accessory-add-to-cart]');
    const cards = section.querySelectorAll('[data-accessory-card]');

    function formatMoney(cents) {
      const value = cents / 100;
      const withComma = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const noDecimals = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return moneyFormat
        .replace('{{amount_with_comma_separator}}', withComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals)
        .replace('{{amount_no_decimals}}', noDecimals)
        .replace('{{amount}}', value.toFixed(2));
    }

    function recalcTotal() {
      let total = basePrice;
      cards.forEach((card) => {
        const qtyEl = card.querySelector('[data-accessory-qty]');
        const qty = parseInt(qtyEl.textContent, 10) || 0;
        const price = parseInt(card.dataset.price || '0', 10);
        total += qty * price;
      });
      if (totalEl) totalEl.innerHTML = formatMoney(total);
    }

    cards.forEach((card) => {
      const qtyEl = card.querySelector('[data-accessory-qty]');
      const minus = card.querySelector('[data-accessory-qty-minus]');
      const plus = card.querySelector('[data-accessory-qty-plus]');
      minus?.addEventListener('click', () => {
        const qty = Math.max(0, (parseInt(qtyEl.textContent, 10) || 0) - 1);
        qtyEl.textContent = qty;
        card.classList.toggle('is-selected', qty > 0);
        recalcTotal();
      });
      plus?.addEventListener('click', () => {
        const qty = (parseInt(qtyEl.textContent, 10) || 0) + 1;
        qtyEl.textContent = qty;
        card.classList.toggle('is-selected', qty > 0);
        recalcTotal();
      });
    });

    addButton?.addEventListener('click', () => {
      const mainVariantInput = document.querySelector('[data-alpha-variant-id]');
      const items = [];
      if (mainVariantInput?.value) {
        items.push({ id: parseInt(mainVariantInput.value, 10), quantity: 1 });
      }
      cards.forEach((card) => {
        const qty = parseInt(card.querySelector('[data-accessory-qty]').textContent, 10) || 0;
        if (qty > 0 && card.dataset.variantId) {
          items.push({ id: parseInt(card.dataset.variantId, 10), quantity: qty });
        }
      });
      if (!items.length) return;
      const originalText = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'Adicionando...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('cart-add-failed');
          return response.json();
        })
        .then(() => {
          window.location.href = '/cart';
        })
        .catch(() => {
          addButton.disabled = false;
          addButton.textContent = originalText;
          alert('Não foi possível adicionar os produtos ao carrinho. Tente novamente.');
        });
    });
  });

  document.querySelectorAll('[data-alpha-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-alpha-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-alpha-slider-dot]'));
    const prev = slider.querySelector('[data-alpha-slider-prev]');
    const next = slider.querySelector('[data-alpha-slider-next]');
    if (slides.length < 2) return;
    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;
    const speed = Number(slider.dataset.speed || 5000);
    const autoplay = slider.dataset.autoplay === 'true';
    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = null; };
    const start = () => { if (autoplay) { stop(); timer = window.setInterval(() => show(index + 1), speed); } };
    prev?.addEventListener('click', () => { show(index - 1); start(); });
    next?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.alphaSliderDot || 0)); start(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    start();
  });

  document.querySelectorAll('.alpha-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adicionando...';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: {'Accept':'application/json'}, body: new FormData(form)
        });
        if (!response.ok) throw new Error('Falha ao adicionar');
        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then(r => r.json());
        document.querySelectorAll('[data-alpha-cart-count]').forEach(el => el.textContent = cart.item_count);
        button.textContent = 'Adicionado!';
      } catch (error) {
        button.textContent = 'Tente novamente';
      } finally {
        setTimeout(() => { button.disabled = false; button.textContent = original; }, 1800);
      }
    });
  });
});
